/* Progressive enhancements only: never intercept commerce or checkout. */
(() => {
  if (!customElements.get('lc-feature-tabs')) {
    class LedclawFeatureTabs extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (this.tabs.includes(tab)) this.activate(this.tabs.indexOf(tab));
        }, {signal: this.controller.signal});
        this.addEventListener('keydown', (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index < 0) return;
          const next = {ArrowRight: (index + 1) % this.tabs.length,
            ArrowLeft: (index - 1 + this.tabs.length) % this.tabs.length,
            Home: 0, End: this.tabs.length - 1}[event.key];
          if (next !== undefined) { event.preventDefault(); this.activate(next, true); }
        }, {signal: this.controller.signal});
        this.activate(0);
      }
      activate(index, focus = false) {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
        if (focus) this.tabs[index]?.focus();
      }
      disconnectedCallback() { this.controller?.abort(); }
    }
    customElements.define('lc-feature-tabs', LedclawFeatureTabs);
  }
  document.addEventListener('click', (event) => {
    const menu = event.target.closest('.lc-menu');
    if (menu && event.target.closest('a')) menu.open = false;
    if (!menu) document.querySelectorAll('.lc-menu[open]').forEach(el => { el.open = false; });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.lc-menu[open]').forEach(menu => {
      menu.open = false; menu.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest('[role="tabpanel"]');
    const tabs = panel?.closest('lc-feature-tabs');
    if (tabs?.panels) tabs.activate(tabs.panels.indexOf(panel));
  });
})();
